import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type TenderBid from '@/domains/TenderBids/TenderBid';

class TenderBidsDAO {

	/**
	 * Загрузить ставку по ID
	 */
	static async getBid(
    filters: {
      id: number
    }
  ): Promise<RpcResponse> {
		return await RpcService.makeRequest('tenders.getBid', filters);
	}

	/**
	 * Создать ставку
	 */
	static async addBid(tenderBid: TenderBid): Promise<RpcResponse> {
		return await RpcService.makeRequest('tenders.addBid', {
			tenderBid,
		});
	}

	/**
	 * Обновить ставку
	 */
	static async updateBid(tenderBid: TenderBid): Promise<RpcResponse> {
		return await RpcService.makeRequest('tenders.updateBid', {
			tenderBid,
		});
	}

	/**
	 * Удалить ставку
	 */
	static async deleteBid(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('tenders.deleteBid', {
			id,
		});
	}
}

export default TenderBidsDAO;
